document.addEventListener( 'click', ( event ) => {
	const target = event.target.closest( '.kids_splitscreen__text-link, .kids_splitscreen__link' );
	if ( !target ) return;

	window.dataLayer = window.dataLayer || [];
	dataLayer.push( { ecommerce: null } );
	dataLayer.push( {
		event: 'kids_splitscreen_click',
		url: window.location.href,
		ecommerce: {
			link_url: target.href || null
		}
	} );
} );
